import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Base_url } from '../../utils/Base_url';

const workerService = createApi({
  reducerPath: 'worker',
  tagTypes: 'workers',
  baseQuery: fetchBaseQuery({
    baseUrl: `${Base_url}/v1/manager/`
  }),
  endpoints: (builder) => {
    return {
      create: builder.mutation({
        query: (name) => {
          return {
            url: 'create-worker',
            method: 'POST',
            body: name
          };
        }
      }),
      updateworker: builder.mutation({
        query: (data) => {
          return {
            url: `update/${data.id}`,
            method: 'PUT',
            body: { name: data.name }
          };
        }
      }),
      deleteworker: builder.mutation({
        query: (id) => {
          return {
            url: `delete/${id}`,
            method: 'DELETE'
          };
        }
      }),

      fetchworker: builder.query({
        query: (id) => {
          return {
            url: `get/${id}`,
            method: 'GET'
          };
        }
      }),
      allworkers: builder.query({
        query: () => {
          return {
            url: 'all-worker',
            method: 'GET'
          };
        }
      })
    };
  }
});
export const {
  useCreateMutation,
  useFetchworkerQuery,
  useAllworkersQuery,
  useUpdateworkerMutation,
  useDeleteworkerMutation
} = workerService;
export default workerService;
